import React, { useState, useEffect, useRef } from "react";

const ApprovalDropdown = ({ 
  post, 
  onPostNow, 
  onCustomSchedule,
  calculatedDate  // NEW PROP
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Get variant number from post (variantNumber or default to 1)
  const variantNumber = post.variantNumber || 1;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  /**
   * Get the description text for the "Post Now" option based on calculated date
   */
  const getPostNowDescription = () => {
    // Show loading state while date is being calculated
    if (!calculatedDate) {
      return "Calculating schedule...";
    }
    
    if (variantNumber === 1) {
      return "Schedule for immediate publishing";
    }
    
    // Format the calculated date
    const dateStr = calculatedDate.toLocaleDateString('en-US', { 
      month: '2-digit', 
      day: '2-digit', 
      year: '2-digit' 
    });
    
    return `Schedule for ${dateStr} at 12:00 PM`;
  };

  const handleOptionClick = (action) => {
    setIsOpen(false);
    
    switch (action) {
      case 'post-now':
        // Pass the variant number to the handler so it can calculate the correct date
        onPostNow(post, variantNumber);
        break;
      case 'custom-schedule':
        onCustomSchedule(post);
        break;
      default:
        break;
    }
  };

  const postNowDescription = getPostNowDescription();

  return (
    <div className="approval-dropdown-container" ref={dropdownRef} id={`approvalDropdown-${post.provider}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="social-post-approve-btn approval-dropdown-trigger"
        id={`approvalDropdownTrigger-${post.provider}`}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        Approve
        <svg 
          className={`approval-dropdown-chevron ${isOpen ? 'open' : ''}`}
          width="16" 
          height="16" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>
      
      {isOpen && (
        <div className="approval-dropdown-menu" id={`approvalDropdownMenu-${post.provider}`}>
          <button
            onClick={() => handleOptionClick('post-now')}
            className="approval-dropdown-option approval-dropdown-post-now"
            id={`approvalDropdownPostNow-${post.provider}`}
          >
            <div className="approval-dropdown-option-content">
              <span className="approval-dropdown-option-title">
                {variantNumber === 1 ? "Post Now" : "Approve"}
              </span>
              <span className="approval-dropdown-option-description">
                {postNowDescription}
              </span>
            </div>
          </button>
          
          <button
            onClick={() => handleOptionClick('custom-schedule')}
            className="approval-dropdown-option approval-dropdown-custom-schedule"
            id={`approvalDropdownCustomSchedule-${post.provider}`}
          >
            <div className="approval-dropdown-option-content">
              <span className="approval-dropdown-option-title">Custom Schedule</span>
              <span className="approval-dropdown-option-description">
                Choose specific date and time
              </span>
            </div>
          </button>
        </div>
      )}
    </div>
  );
};

export default ApprovalDropdown;